export function resolveVuetifyTheme(): string {
  return 'light'
}
